import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { Typography, Card, Table } from 'antd';
import HKServiceTable from '@components/HKServiceTable';
import RegionChart from '../../Regions/chart';

import UsersActions from '@redux/UsersRedux';
import API from '@utils/api';

const { Text } = Typography;

const renderProperty = (name, row) => {
  const { address, buildingNames, propertyID } = row;
  return (
    <Link to={`/properties/${propertyID}`}>
      <div>
        <Text strong>{name}</Text>
      </div>
      <div>
        <Text>
          {address} {buildingNames}{' '}
        </Text>
      </div>
    </Link>
  );
};

const preferenceColumns = [
  {
    title: 'Property ID',
    dataIndex: 'propertyID',
    key: 'propertyID'
  },
  {
    title: 'Property',
    dataIndex: 'name',
    key: 'name',
    render: renderProperty
  },
  {
    title: 'Preference',
    dataIndex: 'weight',
    key: 'weight'
  }
];

const HouseKeeperInfo = props => {
  const {
    userId,
    data: { preference, availabiliies, regionHours },
    updateHkAvailabilities
  } = props;

  const handleUpdateAvailabilities = async (row, editingKey) => {
    const newAvailabilities = availabiliies.map(item => {
      // eslint-disable-next-line no-unused-vars
      const { availabilityID, housekeeperID, ...restItem } = item;
      if (availabilityID === editingKey) {
        return {
          ...restItem,
          ...row
        };
      }

      return restItem;
    });

    const { result } = await API.updateHkAvailability(
      userId,
      newAvailabilities
    );

    updateHkAvailabilities(result);
  };

  return (
    <div
      className="extra_content"
      style={{ paddingTop: 16, display: 'flex', flexDirection: 'row' }}
    >
      <div style={{ flex: 1, paddingRight: 8 }}>
        <Card title="Properties">
          <Table
            dataSource={preference}
            columns={preferenceColumns}
            pagination={false}
          />
        </Card>
      </div>
      <div style={{ flex: 1, paddingLeft: 8 }}>
        <Card title="Availability">
          <HKServiceTable
            availabiliies={availabiliies}
            saveRowResolver={handleUpdateAvailabilities}
          />
        </Card>
        <div style={{ flex: 1, paddingTop: 20 }}>
          <RegionChart data={regionHours} />
        </div>
      </div>
    </div>
  );
};

HouseKeeperInfo.propTypes = {
  data: PropTypes.object,
  userId: PropTypes.string,
  updateHkAvailabilities: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  updateHkAvailabilities: data => {
    dispatch(UsersActions.updateHkAvailabilities(data));
  }
});

export default connect(
  null,
  mapDispatchToProps
)(HouseKeeperInfo);
